import { render, staticRenderFns } from "./ShopView04.vue?vue&type=template&id=ba6af754&scoped=true&"
import script from "./ShopView04.vue?vue&type=script&lang=js&"
export * from "./ShopView04.vue?vue&type=script&lang=js&"
import style0 from "./ShopView04.vue?vue&type=style&index=0&id=ba6af754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6af754",
  null
  
)

export default component.exports